<template>
   <div class="page-deliver-todo">
      <div class="pg-breadcrumb">
         <div class="breadcrumb-item em">派送專線</div>
         <div class="breadcrumb-item">已派送訂單</div>
      </div>
      <div class="card-block">
         <Form inline class="pg-form-inline">
            <FormItem>
               <Select size="small" placeholder="操作人" v-model="form.deliverer_id" clearable>
                  <Option :value="item.user_id" v-for="(item, index) in pickAdmin"
                          :key="item.user_id">{{ item.username }} ({{ item.realname }})
                  </Option>
               </Select>
            </FormItem>

            <FormItem>
               <Select size="small" placeholder="派送專線" @on-change="handleStoreChange(form.store_id)"
                       v-model="form.store_id" clearable>
                  <Option :value="item.id" v-for="(item, index) in deliveryareaList" :key="item.id">{{ item.name }}
                  </Option>
               </Select>
            </FormItem>

            <FormItem>
               <Select size="small" placeholder="派送地址" v-model="form.add_id" ref="resetSelect" clearable>
                  <Option :value="item.id" v-for="(item, index) in deliverybuildingList"
                          :key="item.id">{{ item.name }}
                  </Option>
               </Select>
            </FormItem>

            <FormItem>
               <DatePicker class="no-suffix" type="date" size="small" :clearable="true"
                           placeholder="已派送訂單-開始日期" v-model="form.start_time" value-format="yyyy-MM-dd"
                           :editable="false" style='width: 100%;'>
               </DatePicker>
            </FormItem>
            <FormItem>-</FormItem>
            <FormItem>
               <DatePicker class="no-suffix" type="date" size="small" :clearable="true"
                           placeholder="已派送訂單-結束日期" v-model="form.end_time" value-format="yyyy-MM-dd" :editable="false"
                           style='width: 100%;'>
               </DatePicker>
            </FormItem>
         </Form>
         <Form inline class="pg-form-inline form-input-wrap">
            <FormItem>
               <label class="input-label">快遞單號</label>
               <Input size="small" v-model="form.odd_number" @keyup.enter.native="handleSearch()" clearable></Input>
            </FormItem>
            <FormItem>
               <label class="input-label">客戶名稱</label>
               <Input size="small" v-model="form.user_name" @keyup.enter.native="handleSearch()" clearable>
               </Input>
            </FormItem>
            <FormItem>
               <label class="input-label">客戶電話</label>
               <Input size="small" v-model="form.user_phone" @keyup.enter.native="handleSearch()" clearable></Input>
            </FormItem>
            <FormItem>
               <div class="pg-btn-wrap">
                  <div class="pg-btn style1" @click="handleSearch">搜索</div>
                  <a target="_blank" class="pg-btn style2" @click="handleExport"
                     style="margin-left: 15px;">導出excel</a>
               </div>
            </FormItem>
         </Form>
      </div>

      <div class="card-block pd-bt">
         <Spin fix class="pg-sub-loading" v-if="isSubmiting">
            <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
            <div class="loading-text">Loading</div>
         </Spin>
	
	      <!--         <Table size="small"
												border
												no-data-text="暫無數據"
												:columns="table.column"
												:data="table.data">
								 </Table>-->
         <el-table
	         :data="table.data"
	         style="width: 100%;margin-bottom: 20px;"
	         row-key="id"
	         border
	         height="620"
	         :tree-props="{children: 'order', hasChildren: 'hasChildren'}">
            <!--				odd_number-->
	         <!--				deliverys_name-->
	         <!--				order_reserve_time-->
	         <!--				deliverypoint-->
	         <!--				user_phone-->
	         <!--				user_name-->
	         <!--				快遞單號-->
	         <!--				派送專線-->
	         <!--				預約時間-->
	         <!--				預約地址-->
	         <!--				客戶號碼-->
	         <!--				客戶名稱-->
            <el-table-column label="操作" width="150">
               <template slot-scope="scope">
                  <el-button
	                  v-if="scope.row.parent"
	                  style="background-color: #FF466B;color: #fff;margin-left: 20px;"
	                  size="defalut"
	                  @click="handlePrint(scope.$index, scope.row)">
			              <span>打印</span>
			            </el-button>
               </template>
            </el-table-column>
            <el-table-column
	            prop="order_pay_order"
	            label="流水號/快遞單號"
	            sortable
	            width="180">
            </el-table-column>
            <el-table-column
	            prop="area_name"
	            label="派送專線"
	            sortable
	            width="180">
            </el-table-column>
	         <el-table-column
			         prop="delivery_name"
			         label="預約大廈">
	         </el-table-column>
	         <el-table-column
			         prop="address_remark"
			         min-width="180"
			         label="預約地址">
	         </el-table-column>
            <el-table-column
	            prop="created_at"
	            label="预约時間/貨架號">
            </el-table-column>
            <el-table-column
	            prop="user_phone"
	            label="客戶號碼/客服名称">
            </el-table-column>
         </el-table>

         <div class="pg-pagger">
            <Row>
               <Col span="11" class="pagger-left">
                  <div class="pagger-total">總共{{ totalCount }}條記錄</div>
               </Col>
               <Col span="13" class="pagger-right">
                  <!-- v-if="totalCount > curPageSize" -->
                  <div>
                     <div class="pagger-sizer">
                        <span>每頁</span>
                        <Select v-model="curPageSize" size="small" placeholder="數量"
                                @on-change="handlePageSizeChange">
                           <Option :value="10">10</Option>
                           <Option :value="20">20</Option>
                           <Option :value="30">30</Option>
                           <Option :value="40">40</Option>
                           <Option :value="50">50</Option>
                        </Select>
                     </div>

                     <div class="pagger-elevator">
                        <span>跳轉</span>
                        <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                               @on-enter="handlePageEnter"/>
                     </div>

                     <Page size="small"
                           :current="pageIndex"
                           :page-size="curPageSize"
                           :total="totalCount"
                           @on-change="handlePageChange">
                     </Page>
                  </div>
               </Col>
            </Row>
         </div>

      </div>
	   <PrintInCode2 ref="printInCode2_ref"/>
   </div>
</template>

<script>
import axios from 'axios';
import PrintInCode2 from "../../../components/PrintInCode2";
export default {
	components: {
		PrintInCode2
	},
	data() {
		return {
			printInCode2_ref: null,
			pageIndex: 1,   //页码
			curPageSize: 10,    //一页数量
			totalCount: 1, //总条数
			pageInput: '',  //输入的页码
			deliveryareaList: [], //派送專線
			deliverybuildingList: [], //派送專線大廈
			pickAdmin: [],
			form: {
				add_id: '', //關聯地址ID
				store_id: '',  //關聯專線id
				deliverer_id: '', //派送員ID
				odd_number: '', //快遞單號
				user_name: '', //客户名稱
				user_phone: '', //客户電話
				order_status: 5, //订单派送状态0待派送,无动作,3派送中,5派送完毕,待用户确认
				submission_time: true, //派送时间
				start_time: '', //预约时间
				end_time: '', //预约时间
			},
			isSubmiting: false,
			// isLoading: true,
			exportLink: '', //导出地址
			table: {
				column: [
					// {
					//     title: '序號',
					//     key: 'id',
					//     align: 'center',
					//     sortable: true,
					//     minWidth: 50
					// },
					{
						title: '快遞單號',
						key: 'odd_number',
						align: 'center',
						sortable: true,
						minWidth: 150
					},
					{
						title: '派送專線',
						key: 'deliverys_name',
						align: 'center',
						sortable: true,
						width: 100
					},
					{
						title: '預約時間',
						key: 'order_reserve_time',
						align: 'center',
						sortable: true,
						width: 250
					},
					{
						title: '預約地址',
						key: 'deliverypoint',
						align: 'center',
						sortable: true,
						minWidth: 150
					},
					{
						title: '客戶號碼',
						key: 'user_phone',
						align: 'center',
						sortable: true,
						minWidth: 100
					},
					{
						title: '客戶名稱',
						key: 'user_name',
						align: 'center',
						sortable: true,
						minWidth: 100
					},
					{
						title: '簽收時間',
						key: 'submission_time',
						align: 'center',
						sortable: true,
						width: 150
					},
					{
						title: '操作人',
						key: 'delivery_man',
						align: 'center',
						sortable: true,
						minWidth: 100
					},
					// {
					//     title: '操作',
					//     slot: 'action',
					//     align: 'center',
					//     minWidth: 100
					// }
				],
				data: []
			}
		};
	},
	
	mounted() {
		this.getDeliveryareaList();
		this.getDeliveryareaBuildingList();
		this.getPickAdmin();
		this.getList();
	},
	activated() {
		this.getDeliveryareaList();
		this.getDeliveryareaBuildingList();
		this.getPickAdmin();
		this.getList();
	},
	methods: {
		async handlePrint(index, row) {
			const form = this.form
			
			let token = localStorage.getItem('jyb_token');
			let params = {
				Authorization: token,
				order_flows: row.order_pay_order
			};
			this.$refs.printInCode2_ref.printCode(row.order_pay_order,(res) => {
				if (res == 'yes') {
					this.$message.success('打印成功')
					this.getList()
				}else {
					this.$message.error('打印失败')
				}
			})
			
			// window.open(`${this.$Api.deliverCode3}?${this.$Utils.formateObjToParamStr(params)}`, '_blank');
			// setTimeout(() => this.getList(), 1000)
		},
		handleStoreChange(index) {
			this.$refs.resetSelect.clearSingleSelect();
			this.getDeliveryareaBuildingList(index);
		},
		rowClassName(row, index) {
			if (row.order_number_status === 0) {
				return 'row-red';
			} else if (row.order_number_status === 1) {
				return 'row-yellow';
			} else if (row.order_number_status === 2) {
				return 'row-green';
			}
			return '';
		},
		insertStr(soure, start, newStr) {
			return soure.slice(0, start) + newStr + soure.slice(start);
		},
		//派送專線
		getDeliveryareaList() {
			this.$Rq.requestAuth({
				url: this.$Api.deliveryareaList,
				method: 'get',
			}).then((res) => {
				if (res.code == 0) {
					this.deliveryareaList = res.data.data;
				}
			});
		},
		//派送專線大廈
		getDeliveryareaBuildingList(list) {
			if (list != null) {
				let form = this.form;
				this.$Rq.requestAuth({
					url: this.$Api.deliveryareaAddressList,
					method: 'get',
					data: {
						d_id: list,
						offset: 0,
						limit: 10000,
					},
				}).then((res) => {
					if (res.code == 0) {
						this.deliverybuildingList = res.data.data;
					}
				});
			} else {
				this.deliverybuildingList = [];
			}
		},
		//操作人
		getPickAdmin() {
			this.$Rq.requestAuth({
				url: this.$Api.pickAdmin,
				method: 'post',
				data: {
					user_role: 3
				}
			}).then((res) => {
				if (res.code == 0) {
					this.pickAdmin = res.data.data;
				}
			});
		},
		formatDate(datetime) {
			if (!datetime) return '';
			
			let dateTime = new Date(datetime);
			let year = dateTime.getFullYear();
			let month = dateTime.getMonth() + 1;
			let date = dateTime.getDate();
			let hour = dateTime.getHours();
			let minute = dateTime.getMinutes();
			let second = dateTime.getSeconds();
			let milliseconds = dateTime.getMilliseconds();
			return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)}`;
		},
		formatNum(num) {
			return num < 10 ? '0' + num : num;
		},
		getList() {
			let form = this.form;
			const store_id = JSON.parse(localStorage.getItem('jyb_logInfo')).store_id;
			this.isSubmiting = true;
			this.$Rq.requestAuth({
				url: this.$Api.AreaList_new,
				method: 'get',
				data: {
					store_id: store_id,
					add_id: form.add_id,
					deliverer_id: form.deliverer_id,
					odd_number: form.odd_number,
					user_name: form.user_name,
					user_phone: form.user_phone,
					order_status: form.order_status,
					start_time: this.formatDate(form.start_time),
					end_time: this.formatDate(form.end_time),
					submission_time: form.submission_time,
					offset: (this.pageIndex - 1) * this.curPageSize,
					limit: this.curPageSize,
				}
			}).then((res) => {
				this.isSubmiting = false;
				if (res.code == 0) {
					this.table.data = res.data?.data.map(item => {
						if (item.order) {
							item.order.map(ite => {
								ite.order_pay_order = ite.odd_number
								ite.created_at = ite.shelf_coded
								ite.user_phone = ite.user_name
								return ite
							})
						}
						item.parent = true;
						return item
					});
					this.totalCount = res.data.count || 0;
				}
			}).catch((err) => {
				this.isSubmiting = false;
			});
		},
		
		handleSearch() {
			this.pageIndex = 1;
			this.getList();
		},
		
		handleEdit(index) {
			let tableData = this.table.data;
			this.$router.push({path: '/deliverTodoEdit?id=' + tableData[index].id});
		},
		handleDelete(index) {
			this.$Modal.confirm({
				title: '提示',
				content: '確定刪除嗎？',
				cancelText: '取消',
				okText: '確定',
				onOk: () => {
					let tableData = this.table.data;
					this.isSubmiting = true;
					
					this.$Rq.requestAuth({
						url: this.$Api.deliverDelete + '/' + tableData[index].id,
						method: 'delete'
					}).then((res) => {
						this.isSubmiting = false;
						
						if (res.code == 0) {
							this.$Utils.showSuccess(res.msg);
							
							if (tableData.length <= 1 && this.pageIndex > 1) {
								this.pageIndex -= 1;
							}
							
							this.getList();
							
						} else {
							this.$Utils.showTipInfo(res.msg);
						}
					}).catch((err) => {
						this.isSubmiting = false;
					});
					
				}
			});
		},
		handleExport() {
			let token = localStorage.getItem('jyb_token');
			let form = this.form;
			let params = {
				'Authorization': token,
				store_id: form.store_id,
				add_id: form.add_id,
				deliverer_id: form.deliverer_id,
				odd_number: form.odd_number,
				user_name: form.user_name,
				user_phone: form.user_phone,
				order_status: form.order_status,
				start_time: this.formatDate(form.start_time),
				end_time: this.formatDate(form.end_time),
				submission_time: form.submission_time,
			};
			let formatParams = this.$Utils.formateObjToParamStr(params);
			// if(form.start_time == ''){
			//     this.$Utils.showTipInfo("請選擇珠海入庫起始時間");
			// }
			// else if(form.end_time == ''){
			//     this.$Utils.showTipInfo("請選擇珠海入庫结束時間");
			// }
			// else{
			//     this.getList();
			//     window.open(`${this.$Api.deliveryareaExcelList}?${formatParams}`, '_blank');
			// }
			
			this.getList();
			window.open(`${this.$Api.deliveryareaExcelList}?${formatParams}`, '_blank');
		},
		handlePageSizeChange(value) {
			this.pageIndex = 1;
			this.getList();
		},
		handlePageInput() {
			let value = ('' + this.pageInput).replace(/\D/g, '');
			let pageCount = Math.ceil(this.totalCount / this.curPageSize);
			if (value > pageCount) {
				value = pageCount;
			}
			this.pageInput = value;
		},
		handlePageEnter() {
			if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
			if (this.pageInput == 0) {
				this.pageInput = 1;
			}
			this.pageInput = parseInt(this.pageInput);
			this.pageIndex = this.pageInput;
			this.getList();
		},
		handlePageChange(value) {
			this.pageIndex = value;
			this.getList();
		}
	}
};
</script>

<style>
.ivu-table .row-red td {
	background-color: rgb(255, 235, 235);
	color: #FFFFFF;
}

.ivu-table .row-yellow td {
	background-color: rgb(255, 243, 219);
	color: #FFFFFF;
}

.ivu-table .row-green td {
	background-color: rgb(229, 255, 236);
	color: #FFFFFF;
}
</style>

<style lang="scss" scoped>
@import "deliveryareaDone.scss";
</style>
